import { z } from 'zod';
import { isoDateSchema, paginationQuerySchema } from './common.js';

export const activityEntrySchema = z.object({
  id: z.number().int(),
  event: z.string(),
  actorType: z.enum(['user', 'api_key', 'system', 'daemon']),
  actor: z.object({ uuid: z.string(), username: z.string() }).nullable(),
  impersonator: z.object({ uuid: z.string(), username: z.string() }).nullable(),
  ip: z.string().nullable(),
  subjectType: z.string().nullable(),
  subjectId: z.string().nullable(),
  properties: z.record(z.string(), z.unknown()),
  createdAt: isoDateSchema,
});
export type ActivityEntry = z.infer<typeof activityEntrySchema>;

/** A server's activity; `event` narrows it to events starting with that prefix. */
export const serverActivityQuerySchema = paginationQuerySchema.extend({
  event: z.string().trim().max(64).optional(),
});

export const activityQuerySchema = paginationQuerySchema.extend({
  /** Prefix match on the event name, e.g. "auth:" or "admin:user". */
  event: z.string().trim().max(64).optional(),
  /** Admin only: filter by actor user UUID. */
  actor: z.uuid().optional(),
  /** Admin only: entries where this user UUID is the actor or the subject. */
  user: z.uuid().optional(),
});
